export default __webpack_public_path__ + "static/media/pt-loader.05f35b45.gif";